import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import AcademicYearSelect from './AcademicYearSelect'
import Button from '../mini/Buttons/Button'
import { showModal } from '../../actions/modal'
import colors from '../../configuration/colors'

const HeaderContainer = styled.div`
  display: flex;
  margin: 58px 0;
  justify-content: space-between;
  align-items: center;
`

const FlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const UserAvatarImage = styled.img.attrs({
  src: props => props.userAvatar
})`
  width: 60px;
  height: 60px;
  border-radius: 5px;
  margin-right: 18px;
`

const HeaderText = styled.h1`
  height: 40px;
  width: 182px;
  color: #263746;
  font-size: 34px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 40px;
  margin: 0;
`

const UserOrganizationName = styled.p`
  height: 21px;
  margin: 0;
  color: #444444;
  font-size: 16px;
  font-weight: 300;
  letter-spacing: 0;
  line-height: 20.8px;
  text-align: left;
`

const AcademicYearSelectionBlock = styled.div`
  margin-right: 31px;
  width: 245px;
`

const Header = ({
  dispatch,
  user,
  organization,
  academicYears,
  selectedAcademicYear,
  handleSelectedAcademicYearChange,
  frameworkSubjects,
  gradeLevels,
  orgFlags
}) => {
  const handleModalOpen = () => {
    dispatch(
      showModal('STARTER_COURSE_MODAL', {
        dispatch,
        user,
        organization,
        academicYears,
        frameworkSubjects,
        gradeLevels,
        selectedAcademicYearId: selectedAcademicYear.id,
        orgFlags
      })
    )
  }

  return (
    <HeaderContainer>
      <FlexContainer>
        <UserAvatarImage userAvatar={user.photo.url} alt="user-avatar" />
        <div>
          <HeaderText>My Courses</HeaderText>
          <UserOrganizationName>{user.org_name}</UserOrganizationName>
        </div>
      </FlexContainer>
      <FlexContainer>
        <AcademicYearSelectionBlock className="academic-year-select">
          <AcademicYearSelect
            academicYears={academicYears}
            handleSelectedAcademicYearChange={handleSelectedAcademicYearChange}
            selectedAcademicYear={selectedAcademicYear}
          />
        </AcademicYearSelectionBlock>
        <Button
          handleClick={handleModalOpen}
          width="211px"
          title="+ Create a New Course"
          buttonColor={colors.oeYellow}
          borderColor={colors.oeYellow}
          hoverBackground={colors.charcoal4}
          hoverColor={colors.white}
        />
      </FlexContainer>
    </HeaderContainer>
  )
}

Header.propTypes = {
  dispatch: PropTypes.func,
  user: PropTypes.object,
  frameworkSubjects: PropTypes.array.isRequired,
  gradeLevels: PropTypes.array.isRequired
}

export default Header



// WEBPACK FOOTER //
// ./src/components/mycourses/Header.js